import { Component, OnInit } from '@angular/core';
import { SearchService } from '../../../services/search.service';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'search-results',
  templateUrl: 'search-results.component.html'
})
export class SearchResultsComponent extends BaseComponent implements OnInit {

    results: any[];
    totalFound: number = 0;

    constructor(
        private searchService: SearchService,
        private route: ActivatedRoute,
        private router: Router
    ) {
        super(route);
    }

    ngOnInit(): void {
        if (this.searchService.searchRequest == null) {
            this.router.navigateByUrl('/search');
        }
        else {
            this.results = this.searchService.results;
            this.totalFound = this.searchService.paging.totalItems;
        }
    }

    loadMoreResults() {
        if (this.searchService.hasMoreResults()) {
            this.emitDisplayLoadingDialog(true);
            this.searchService.loadMoreResults()
                .subscribe(returnValue => {
                    this.refreshResults();
                },
                error => {
                    this.emitDisplayLoadingDialog(false);
                });
        }
    }

    viewProfile(mbno: string) {
        this.emitDisplayLoadingDialog(true);
        this.router.navigateByUrl('/profile/' + mbno);
    }

    refreshResults() {
        this.emitDisplayLoadingDialog(false);
        this.results = this.searchService.results;
    }

    hasMoreResults(): boolean {
        return this.searchService.hasMoreResults();
    }

}
